/**
 * APP LOGOS
 *
 * app logos need to be passed as a url into reown,
 * new URL is used to bypass svgr importing all svg's as react components
 */
/* @vite-ignore */
const onLight = new URL("src/assets/app/logo-onlight.svg", import.meta.url).href;
/* @vite-ignore */
const onDark = new URL("src/assets/app/logo-ondark.svg", import.meta.url).href;

// app version
import pcg from "../../../package.json";
const [version, label] = pcg.version.split("-");

const baseURL = "TODO.finance";
export const app = {
  name: "TODO",
  description: "TODO",
  // Replace this with your actual WalletConnect project ID from https://cloud.walletconnect.com/
  projectId: import.meta.env.VITE_WALLETCONNECT_PROJECT_ID as string,
  homeURL: `https://${baseURL}`,
  appURL: `https://app.${baseURL}`,
  docsURL: `https://docs.${baseURL}/docs`,
  onDark,
  onLight,
  version,
  label,
};
